import type { ReactNode } from 'react';
import classnames from 'classnames';

interface ISelectRowProps {
    children: ReactNode;
    isSelected: boolean;
    onClick: () => void;
}

export function SelectRow(props: ISelectRowProps) {
    return (
        <tr
            className={classnames('clickable-row select-row', { selected: props.isSelected })}
            onClick={props.onClick}
        >
            {props.children}
        </tr>
    );
}
